import React from 'react';
import { useHover } from 'react-use';
import classNames from 'classnames';
import IconArrow from '@components/icons/IconArrow';
import onClickAndHold from '@utils/onClickAndHold';

export type Direction = 'up' | 'down' | 'left' | 'right';

function MoveBtn({
  direction,
  onClick,
}: {
  direction: Direction;
  onClick: (val: Direction) => void;
}) {
  const [btn] = useHover((isHovered) => (
    <div
      className="flex h-30 w-30 cursor-pointer items-center justify-center rounded bg-black-#34"
      onMouseDown={() => onClickAndHold(() => onClick(direction))}
    >
      <IconArrow
        active={isHovered}
        className={classNames('transform', {
          'rotate-90': direction === 'left',
          '-rotate-90': direction === 'right',
          'rotate-180': direction === 'up',
        })}
      />
    </div>
  ));
  return btn;
}

export default MoveBtn;
